import { render, staticRenderFns } from "./BoxChartCheckBox.vue?vue&type=template&id=33e86472&scoped=true"
import script from "./BoxChartCheckBox.vue?vue&type=script&lang=js"
export * from "./BoxChartCheckBox.vue?vue&type=script&lang=js"
import style0 from "./BoxChartCheckBox.vue?vue&type=style&index=0&id=33e86472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e86472",
  null
  
)

export default component.exports